module.exports = __webpack_public_path__ + "static/media/CTLI_6-111w.f0d5a71a.webp";